import Vue from 'vue';
import Vuex from 'vuex';

import font from './modules/font';
import ui from './modules/ui';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    font,
    ui
  }
})